module.exports = __webpack_public_path__ + "img/code.49b0447e.png";